import { combineReducers } from 'redux';
import reduceReducers from 'reduce-reducers';

import { LOAD_INITIAL_LOCAL_STORAGE } from 'constants/reduxActions';

import onDemandSize from 'reducers/onDemandSize';
import lastSelectedSizes from 'reducers/lastSelectedSizes';

const localStorageReducers = combineReducers({
  lastSelectedSizes,
  onDemandSize
});

function rootLocalStorageReducer(state = {}, action) {
  switch (action.type) {
    case LOAD_INITIAL_LOCAL_STORAGE:
      return {
        ...state,
        ...action.initialLocalStorage
      };
    default:
      return state;
  }
}

export default reduceReducers(localStorageReducers, rootLocalStorageReducer);
